export const FETCH_TRANSACTIONS = 'PAYMENTS/FETCH_TRANSACTIONS'
export const FETCH_TRANSACTIONS_SUCCESS = 'PAYMENTS/FETCH_TRANSACTIONS_SUCCESS'
export const FETCH_TRANSACTIONS_ERROR = 'PAYMENTS/FETCH_TRANSACTIONS_ERROR'
export const FETCH_NEXT_TRANSACTIONS_PAGE = 'PAYMENTS/FETCH_NEXT_TRANSACTIONS_PAGE'
